import { Head } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"

import AuthAlert from "@/components/tuw/auth/AuthAlert"
import { AuthHeading } from "@/components/tuw/auth/AuthHeading"
import AuthLayout from "@/components/tuw/auth/AuthLayout"
import { CsrfField, TextField } from "@/components/tuw/auth/fields"
import { Button } from "@/components/ui/button"

// Forgot password (P11-H2 Spare Key): posts `user[email]` as a plain browser
// form to Devise's passwords path. Whatever the email, the server lands on the
// sent screen, so nothing here can reveal whether an address is registered.
export default function ForgotPassword({ action, email = "", error = null, alert = null, links }) {
  return (
    <AuthLayout panel="reset" swap={{ prompt: "New here?", label: "Create an account", href: links.signUp }}>
      <Head title="Reset your password · The Urban Writers" />

      <AuthHeading title="Reset your password">
        Enter the email on your account and we’ll send you a link to choose a new one.
      </AuthHeading>

      {alert && <AuthAlert tone="bad">{alert}</AuthAlert>}

      <form method="post" action={action} className="flex flex-col gap-4">
        <CsrfField />

        <TextField
          id="user_email"
          name="user[email]"
          type="email"
          label="Email"
          placeholder="you@example.com"
          autoComplete="email"
          defaultValue={email}
          error={error}
          autoFocus
          required
        />

        <div className="mt-[6px] flex flex-col gap-2.5">
          <Button type="submit" className="h-auto w-full rounded-[11px] px-4 py-3 text-[14px] font-semibold">
            Send reset link
          </Button>
          <BackToSignIn href={links.signIn} />
        </div>
      </form>
    </AuthLayout>
  )
}

// The reset screens' quiet way back (design `.btn-ghost`).
export function BackToSignIn({ href }) {
  return (
    <Button
      asChild
      variant="ghost"
      className="h-auto w-full rounded-[11px] px-4 py-3 text-[14px] font-semibold text-muted-foreground hover:text-foreground"
    >
      <a href={href}>
        <ArrowLeft className="size-4" strokeWidth={2} />
        Back to sign in
      </a>
    </Button>
  )
}
